(() => {
  // Several slider sections include this file; run it once (boot() covers every slider on the page).
  if (window.__nuvialleProductSlider) return;
  window.__nuvialleProductSlider = true;

  const truncate = (s) => (s.length > 34 ? `${s.slice(0, 33)}…` : s);

  /* Refresh the header cart count and the theme's cart drawer without opening it */
  const refreshCart = (sections) => {
    if (!sections) return;
    const inner = (html, selector) => {
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? el.innerHTML : null;
    };
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      const html = inner(sections['cart-icon-bubble'], '.shopify-section');
      if (html != null) bubble.innerHTML = html;
    }
    const drawer = document.querySelector('cart-drawer');
    const drawerInner = document.getElementById('CartDrawer');
    if (drawer && drawerInner && sections['cart-drawer']) {
      const html = inner(sections['cart-drawer'], '#CartDrawer');
      if (html != null) {
        drawerInner.innerHTML = html;
        drawer.classList.remove('is-empty');
        const overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
      }
    }
  };

  const init = (root) => {
    if (!root || root.dataset.nvReady) return;
    root.dataset.nvReady = '1';

    const track = root.querySelector('[data-nv-ps-track]');
    const prev = root.querySelector('[data-nv-ps-prev]');
    const next = root.querySelector('[data-nv-ps-next]');
    if (!track) return;

    /* Arrows: step 1.5 cards, disabled at either end */
    const update = () => {
      if (!prev || !next) return;
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    };
    const step = (dir) => {
      const card = track.querySelector('.nv-ps-card:not([hidden])');
      const width = card ? card.offsetWidth + 12 : 240;
      track.scrollBy({ left: dir * width * 1.5, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* Staggered entrance when the slider first scrolls into view */
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      track.classList.add('is-pending');
      const io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          track.classList.add('is-in');
          track.classList.remove('is-pending');
          io.disconnect();
        },
        { threshold: 0.15 }
      );
      io.observe(track);
      // Safety net: never leave cards hidden if the observer doesn't report (e.g. background tabs).
      setTimeout(() => {
        if (track.classList.contains('is-in')) return;
        track.classList.add('is-in');
        track.classList.remove('is-pending');
        io.disconnect();
      }, 3000);
    }

    /* Add to cart + toast */
    const toast = root.querySelector('[data-nv-ps-toast]');
    const toastText = root.querySelector('[data-nv-ps-toast-text]');
    let toastTimer;
    const showToast = (message) => {
      if (!toast || !toastText) return;
      toastText.textContent = message;
      toast.classList.remove('is-show');
      void toast.offsetWidth;
      toast.classList.add('is-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove('is-show'), 2700);
    };

    root.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-nv-ps-add]');
      if (!form) return;
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      const name = form.dataset.title || '';
      if (btn) btn.disabled = true;

      const body = new FormData(form);
      const sections = ['cart-icon-bubble'];
      if (document.querySelector('cart-drawer')) sections.push('cart-drawer');
      body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);

      try {
        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const res = await fetch(`${addUrl}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || 'Add to cart failed');
        refreshCart(data.sections);
        showToast(`Added to bag — ${truncate(name)}`);
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'nuvialle-product-slider', cartData: data });
        }
        document.dispatchEvent(new CustomEvent('nuvialle:item-added', { detail: data }));
      } catch (err) {
        showToast(`Couldn't add — ${truncate(name)}`);
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  };

  const boot = () => document.querySelectorAll('[data-nv-ps]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-nv-ps]')));
})();
